module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_j_erythristic.ea55d1f9.png";